<template>
    <div>
        <div 
        class="d-flex justify-space-between align-center my-2"
        :class="$vuetify.breakpoint.mdAndDown ? 'px-8' : 'px-3'" 
        @click="selectMethod()" style="cursor: pointer">
            <div class="d-flex align-start" :class="isPayment ? 'py-1' : ''">
                <v-icon v-if="!isPayment" color="primary" size="28" class="pr-2 pb-1">{{arrowIcon}}</v-icon>
                <div v-else>
                    <v-btn
                        class="mr-2"
                        icon
                        small
                        color="primary"
                        >
                        <v-icon dark>
                            {{isSelected ? 'fxt-radio-on' : 'fxt-radio-off'}}
                        </v-icon>
                    </v-btn>
                </div>
                <div>
                    <span class="font-weight-bold">{{ title }}</span>
                    <p v-if="isPayment" class="payment__description">{{ description }}</p>
                </div>
            </div>
            <img :src="icon">
        </div>
        <v-expand-transition>
            <div v-if="isPayment ? isSelected : showComponent">
                <slot>Ingen innhold</slot>
            </div>
        </v-expand-transition>
    </div>
</template>
<script>
export default {
    name: "the-consent-toggle-item",
    data: () => ({
        showComponent: false,
    }),
    props: {
        title: {
            required: true,
            default: ''
        },
        icon: {
            required: false,
            default: ''
        },
        description: {},
        isPayment: {},
        isSelected: {}
    },
    methods: {
        selectMethod() {
            this.showComponent = !this.showComponent
            this.$emit('selectPaymentMethod')
        } 
    },
    computed: {
        arrowIcon() {
            return this.showComponent ? 'fxt-chevron-up' : 'fxt-chevron-down'
        }
    }
};
</script>

<style scoped lang="scss">
.payment {
    &__description {
        color: var(--v-primary-base);
        margin-bottom: 0px;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
    }
}
</style>